export default __webpack_public_path__ + "static/media/mys-chindli-chumm-weidli.1d371c19.png";